import { apiConstants } from "../../utils/apiConstants";
import { apiTypes } from "../../utils/apiTypes";
import apiRequestType from "../apiRequestType";

const uploadSlideShare = (data) => {
  return apiRequestType(
    apiTypes.PUT,
    apiConstants.MANAGE.UPLOAD_SLIDESHARE_SHOTCLASS,
    data
  );
};

export default uploadSlideShare;
